// Which release this is and where its data lives, for the line at the foot of the rail. deploy/uat/deploy-web.mjs
// stamps these into the build; a build without them (local development) says so rather than guessing.
export interface Release {
  /** 'production', 'uat', or '' for a local build. */
  env: string
  /** The database the deployed API uses, e.g. control_uat. */
  database: string
  commit: string
  /** ISO time the web bundle was built and published. */
  at: string
}

export function currentRelease(env: Record<string, string | undefined> = import.meta.env): Release {
  return {
    env: env.VITE_RELEASE_ENV || '',
    database: env.VITE_RELEASE_DATABASE || '',
    commit: env.VITE_RELEASE_COMMIT || '',
    at: env.VITE_RELEASE_AT || '',
  }
}

const ENV_NAMES: Record<string, string> = { production: 'Production', uat: 'UAT' }

/** "UAT · control_uat" / "Released 20 Oct 2026, 1:21 pm · 8748bc4", in the viewer's own time zone. */
export function describeRelease(r: Release, timeZone?: string): { where: string; when: string } {
  if (!r.env) return { where: 'Local development', when: r.commit ? r.commit.slice(0, 7) : '' }
  const where = [ENV_NAMES[r.env] || r.env, r.database].filter(Boolean).join(' · ')
  const t = r.at ? new Date(r.at) : null
  const date =
    t && !Number.isNaN(t.getTime())
      ? new Intl.DateTimeFormat('en-NZ', { day: 'numeric', month: 'short', year: 'numeric', hour: 'numeric', minute: '2-digit', timeZone }).format(t)
      : ''
  const when = [date && `Released ${date}`, r.commit.slice(0, 7)].filter(Boolean).join(' · ')
  return { where, when }
}
